<template>
    <ThankYouForRegistering></ThankYouForRegistering>
</template>

<script>
    import ThankYouForRegistering from "../components/ThankYouForRegistering";

    export default {
        name: "thank-you-for-registering",
        components: {
            ThankYouForRegistering,
        }
    };
</script>